var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0634766 14.6382V21.4361H6.74948C7.85408 21.4361 8.74948 20.5406 8.74948 19.4361V12.6382H2.06348C0.958877 12.6382 0.0634766 13.5337 0.0634766 14.6382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3513 4.94096L14.9742 0.563965L10.6708 4.86716C9.88969 5.64836 9.88969 6.91456 10.6708 7.69576L15.0479 12.0728L19.3513 7.76906C20.1324 6.98827 20.1324 5.72216 19.3513 4.94096Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74948 1.92188H0.0634766V8.71978C0.0634766 9.82478 0.958877 10.7198 2.06348 10.7198H8.74948V3.92188C8.74948 2.81737 7.85408 1.92188 6.74948 1.92188Z",
    fill: "#00DEA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.353 12.6382H10.667V19.4361C10.667 20.5406 11.5624 21.4361 12.667 21.4361H19.353V14.6382C19.353 13.5337 18.4576 12.6382 17.353 12.6382Z",
    fill: "#00DEA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.947519a81de2251512554eb352e3f616.svg";
export { ForwardRef as ReactComponent };